module.exports = __webpack_public_path__ + "static/media/betterflosspro-logo.cdd4968c.png";